export default "__VITE_ASSET__Dd7wp5oZ__"